<template>
  <div class="assessment-entry-page">
    <div class="container" :style="{ minHeight: minHeight + 'px' }">
      <Head />
      <img
        class="page-banner"
        src="./../../assets/image/back/qiyeziping_back.jpg"
        alt="企业自评"
      >

      <main class="entry-content">
        <div class="section-heading">
          <h1>企业创新能级评估</h1>
          <p>请选择对应的办事或评估入口</p>
        </div>

        <a
          class="entry-card official-entry"
          href="https://yzt.beijing.gov.cn/am/UI/Login?module=BjzwLDAP&goto=http%3A%2F%2Fyzt.beijing.gov.cn%2Fam%2Foauth2%2Fauthorize%3Fservice%3DbjzwService%26response_type%3Dcode%26client_id%3D693225666_01%26scope%3Dcn%2Buid%2BidCardNumber%2BextProperties%26redirect_uri%3Dhttps%253a%252f%252fbsfw.jxj.beijing.gov.cn%252fusercenter%252fyztLogin%26encoded%3Dfalse&lackFlag=NA"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="entry-icon official-icon"><i class="el-icon-office-building" /></span>
          <span class="entry-copy">
            <strong>北京市企业技术中心运行评价办事入口</strong>
            <small>北京市统一身份认证平台</small>
          </span>
          <i class="el-icon-right entry-arrow" />
        </a>

        <div class="domain-grid">
          <button
            v-for="entry in domainEntries"
            :key="entry.path"
            type="button"
            class="entry-card domain-entry"
            @click="goTo(entry.path)"
          >
            <span class="entry-icon" :class="entry.colorClass"><i :class="entry.icon" /></span>
            <span class="entry-copy">
              <strong>{{ entry.title }}</strong>
              <small>企业创新能级评估入口</small>
            </span>
            <i class="el-icon-right entry-arrow" />
          </button>
        </div>
      </main>
    </div>
    <Footer />
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'SelfAssessment',
  components: { Head, Footer },
  data() {
    return {
      minHeight: 0,
      domainEntries: [
        { title: '人工智能', path: '/aiassessment', icon: 'el-icon-s-platform', colorClass: 'icon-blue' },
        { title: '先进材料', path: '/materialassessment', icon: 'el-icon-s-data', colorClass: 'icon-cyan' },
        { title: '绿色先进能源与低碳环保', path: '/energyassessment', icon: 'el-icon-s-opportunity', colorClass: 'icon-green' },
        { title: '信息软件', path: '/softwareassessment', icon: 'el-icon-monitor', colorClass: 'icon-purple' },
        { title: '集成电路', path: '/integratedcircuitassessment', icon: 'el-icon-cpu', colorClass: 'icon-indigo' },
        { title: '新型安全应急装备', path: '/emergencyassessment', icon: 'el-icon-first-aid-kit', colorClass: 'icon-red' }
      ]
    }
  },
  mounted() {
    this.updateMinHeight()
    window.addEventListener('resize', this.updateMinHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMinHeight)
  },
  methods: {
    updateMinHeight() {
      this.minHeight = Math.max(document.documentElement.clientHeight - 200, 620)
    },
    goTo(path) {
      this.$router.push({ path })
    }
  }
}
</script>

<style lang="scss" scoped>
.assessment-entry-page {
  background: #f5f8fc;
}

.container {
  background: #f5f8fc;
}

.page-banner {
  display: block;
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.entry-content {
  width: 1120px;
  margin: 0 auto;
  padding: 46px 0 64px;
}

.section-heading {
  margin-bottom: 30px;
  text-align: center;

  h1 {
    margin: 0;
    color: #17324d;
    font-size: 28px;
    font-weight: 600;
  }

  p {
    margin: 10px 0 0;
    color: #7b8da1;
    font-size: 15px;
  }
}

.entry-card {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border: 1px solid #dce7f2;
  border-radius: 12px;
  background: #fff;
  color: #17324d;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease;

  &:hover {
    border-color: #8fc9ed;
    box-shadow: 0 12px 28px rgba(34, 92, 135, .12);
    transform: translateY(-2px);
  }
}

.official-entry {
  width: 100%;
  min-height: 104px;
  padding: 22px 30px;
  border-color: #b9e1cd;
  background: linear-gradient(135deg, #f3fbf7 0%, #fff 100%);
}

.domain-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  margin-top: 22px;
}

.domain-entry {
  width: 100%;
  min-height: 118px;
  padding: 22px;
  font-family: inherit;
}

.entry-icon {
  display: flex;
  flex: 0 0 52px;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-right: 16px;
  border-radius: 12px;
  background: #eaf5fc;
  color: #168bc7;
  font-size: 25px;
}

.official-icon {
  background: #dcf4e7;
  color: #15975a;
}

.icon-cyan { background: #e4f7f7; color: #159c9c; }
.icon-green { background: #eaf7e8; color: #4c9c3d; }
.icon-purple { background: #f2ebfa; color: #8652b7; }
.icon-indigo { background: #e9edfb; color: #536ac1; }
.icon-red { background: #fcebec; color: #d8525d; }

.entry-copy {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;

  strong {
    color: #17324d;
    font-size: 17px;
    font-weight: 600;
    line-height: 1.55;
  }

  small {
    margin-top: 6px;
    color: #8797a9;
    font-size: 13px;
  }
}

.official-entry .entry-copy strong {
  font-size: 20px;
}

.entry-arrow {
  margin-left: 12px;
  color: #90a4b7;
  font-size: 18px;
}

@media (max-width: 1199px) {
  .entry-content {
    width: auto;
    padding-right: 24px;
    padding-left: 24px;
  }
}

@media (max-width: 900px) {
  .domain-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .page-banner {
    height: 170px;
  }

  .entry-content {
    padding: 30px 14px 42px;
  }

  .domain-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .official-entry,
  .domain-entry {
    min-height: 94px;
    padding: 18px;
  }

  .entry-icon {
    flex-basis: 46px;
    width: 46px;
    height: 46px;
  }

  .official-entry .entry-copy strong,
  .entry-copy strong {
    font-size: 16px;
  }
}
</style>
